import { render, staticRenderFns } from "./CommuniquerOral.vue?vue&type=template&id=59b1fef1"
import script from "./CommuniquerOral.vue?vue&type=script&lang=js"
export * from "./CommuniquerOral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports